export default "__VITE_ASSET__220cebb1__"